export default __webpack_public_path__ + "static/banner_bg-5c9850c602a595f6cbff613aa0e0d504.webp";